module.exports = "<ng-select #selector\n           [items]=\"options\"\n           [multiple]=true\n           (selected)=\"select($event)\"\n           (removed)=\"deSelect($event)\"\n           [placeholder]=\"placeholder\"\n           [active]=\"active\">\n</ng-select>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/input/select2/select2.template.html
// module id = ./src/app/components/input/select2/select2.template.html
// module chunks = main